<template>
  <schedule-collections
    ref="embeddedSchedulePost"
    embedded
    show-early-job-statuses
    minimal-clip-actions
    collection-detail-view
    block-open-until-rendered
    @collection-focus-change="forwardCollectionFocusChange"
    @collection-deleted="forwardCollectionDeleted"
    @collection-insufficient-tokens-click="forwardCollectionInsufficientTokensClick"
    @clip-schedule-click="forwardClipScheduleClick"
    @clip-editor-visibility-change="forwardClipEditorVisibilityChange"
  />
</template>

<script>
import ScheduleCollections from "@/pages/ScheduleCollections.vue";

export default {
  name: "MakeClipsScheduleLibrary",
  components: {
    ScheduleCollections,
  },
  methods: {
    forwardCollectionFocusChange(payload) {
      if (payload && typeof payload === "object" && !Array.isArray(payload)) {
        this.$emit("collection-focus-change", payload);
        return;
      }
      this.$emit("collection-focus-change", {
        isFocused: !!payload,
        selectedCollection: null,
      });
    },
    forwardCollectionDeleted(payload) {
      this.$emit("collection-deleted", payload || null);
    },
    forwardCollectionInsufficientTokensClick(payload) {
      this.$emit("collection-insufficient-tokens-click", payload || null);
    },
    forwardClipScheduleClick(payload) {
      this.$emit("clip-schedule-click", payload || null);
    },
    forwardClipEditorVisibilityChange(payload) {
      const isPayloadObject = payload && typeof payload === "object" && !Array.isArray(payload);
      this.$emit("clip-editor-visibility-change", {
        isVisible: isPayloadObject ? !!payload.isVisible : !!payload,
        clipId: isPayloadObject ? payload.clipId || null : null,
      });
    },
    async refreshEmbeddedScheduleData() {
      const scheduleComponent = this.$refs.embeddedSchedulePost;
      if (!scheduleComponent || typeof scheduleComponent.refreshEmbeddedScheduleData !== "function") return;
      await scheduleComponent.refreshEmbeddedScheduleData();
    },
    async openScheduleModalForClip(clip) {
      const scheduleComponent = this.$refs.embeddedSchedulePost;
      if (!scheduleComponent || typeof scheduleComponent.openScheduleModal !== "function") return;
      await scheduleComponent.openScheduleModal(clip);
    },
    resetEmbeddedSelection() {
      const scheduleComponent = this.$refs.embeddedSchedulePost;
      if (!scheduleComponent || typeof scheduleComponent.resetEmbeddedCollectionSelection !== "function") return;
      scheduleComponent.resetEmbeddedCollectionSelection();
    },
    closeEmbeddedEditor() {
      const scheduleComponent = this.$refs.embeddedSchedulePost;
      if (!scheduleComponent || typeof scheduleComponent.closeClipTimeEditorModal !== "function") return;
      scheduleComponent.closeClipTimeEditorModal();
    },
  },
};
</script>
